import {useCallback} from "react";
import {postResetKey} from "../api";
import {AdminAction} from "../types";
import {useToast} from "use-toast-mui";

export const useResetKey = () => {
    const toast = useToast();

    const resetKey: AdminAction = useCallback(async (activationKey: string): Promise<void> => {
        try {
            await postResetKey(activationKey);
        } catch (error) {
            toast.error("Error resetting key.");
        }
    }, [toast])

    return {resetKey}
}
